import React from 'react';

const RULES = [
  {
    module: 'Demandes clients',
    icon: '📥',
    regles: [
      {
        champs: 'Nom, Prénom, Téléphone, Email, Commentaires',
        regle: 'Masquage d\'affichage (> 6 mois)',
        detail: 'Les champs PII sont masqués (●●●●●●●●●●) dans l\'interface pour tous les utilisateurs sauf super-admin, 6 mois après la date de la demande. Les données restent intactes en base. Les super-admins voient toujours les données en clair. Les boutons contact (📞 ✉️ 📱) sont désactivés.',
        delai: '6 mois',
        automatique: true,
      },
    ],
  },
  {
    module: 'Portail Constructeur (TAKATA)',
    icon: '🎯',
    regles: [
      {
        champs: 'Nom client, Téléphone, Secteur géographique',
        regle: 'Masquage d\'affichage permanent',
        detail: 'Les données personnelles des clients détectés ne sont jamais transmises aux comptes constructeurs. Affichage systématique en ●●●●●●●●●● pour Client, Téléphone et localisation.',
        delai: 'Permanent',
        automatique: true,
      },
      {
        champs: 'Coordonnées renseignées dans les notes journal',
        regle: 'Remplacement à l\'affichage',
        detail: 'Les lignes « Coordonnées renseignées — … » des notes [Webapp] sont remplacées par « 🔒 Coordonnées client masquées (RGPD) » côté portail constructeur.',
        delai: 'Permanent',
        automatique: true,
      },
    ],
  },
  {
    module: 'Assistant IA (Claude)',
    icon: '🤖',
    regles: [
      {
        champs: 'Historique des conversations IA',
        regle: 'Purge automatique après 90 jours',
        detail: 'Les logs des conversations avec l\'assistant IA (table ai_chat_logs) sont purgés automatiquement chaque nuit à 3h30 après 90 jours. Aucune conversation n\'est conservée au-delà.',
        delai: '90 jours',
        automatique: true,
      },
      {
        champs: 'Données envoyées à l\'IA pour analyse',
        regle: 'Anonymisation avant envoi',
        detail: 'Les données de reporting et les avis clients (JDMA) sont tokenisés temporairement avant envoi à Claude (noms → CONC_1, DEPT_A, etc.). Le mapping de déchiffrement n\'est jamais persisté.',
        delai: 'Temporaire (session)',
        automatique: true,
      },
    ],
  },
  {
    module: 'Analytics & Ads',
    icon: '📊',
    regles: [
      {
        champs: 'Google Analytics, Google Ads, Search Console',
        regle: 'Données agrégées uniquement',
        detail: 'Les intégrations analytics n\'exposent que des métriques agrégées (sessions, clics, conversions). Aucune donnée nominative (PII) n\'est importée ni stockée dans le CRM.',
        delai: 'N/A',
        automatique: true,
      },
    ],
  },
  {
    module: 'Offres commerciales',
    icon: '🏷️',
    regles: [
      {
        champs: 'Noms et prénoms des vendeurs',
        regle: 'Retrait à la source',
        detail: 'Les noms et prénoms des vendeurs sont retirés à la source lors de l\'import des offres. Seul l\'identifiant interne (non nominatif) est conservé dans le CRM.',
        delai: 'Permanent',
        automatique: true,
      },
    ],
  },
  {
    module: 'Planning Atelier',
    icon: '📅',
    regles: [
      {
        champs: 'Recherche client',
        regle: 'Seuil de 3 caractères minimum',
        detail: 'La recherche de client dans le planning ne lance aucune requête serveur en dessous de 3 caractères. En cas de résultats multiples, aucune donnée client n\'est révélée (RGPD).',
        delai: 'N/A',
        automatique: true,
      },
    ],
  },
];

export default function RGPDDashboard() {
  return (
    <div className="page-container">
      <div className="page-tabs">
        <button className="active">🔒 Règles RGPD en vigueur</button>
      </div>

      <div style={{ background: 'var(--bg-surface)', border: '1px solid var(--border-default)', borderRadius: '10px', padding: '16px 20px', display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
        <div>
          <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Masquage Demandes clients</div>
          <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--text-primary)' }}>6 mois</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>masquage display après la date de demande</div>
        </div>
        <div>
          <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Purge logs IA</div>
          <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--text-primary)' }}>90 jours</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>nuit à 3h30 — purge ai_chat_logs</div>
        </div>
        <div>
          <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Visibilité PII en clair</div>
          <div style={{ fontSize: '28px', fontWeight: 700, color: 'var(--text-primary)' }}>Super-admin</div>
          <div style={{ fontSize: '12px', color: 'var(--text-muted)', marginTop: '2px' }}>seul rôle à voir les données non masquées</div>
        </div>
      </div>

      <div className="table-container">
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: 'var(--bg-muted)' }}>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', borderBottom: '1px solid var(--border-default)' }}>Module</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', borderBottom: '1px solid var(--border-default)' }}>Champs concernés</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', borderBottom: '1px solid var(--border-default)' }}>Règle</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', borderBottom: '1px solid var(--border-default)' }}>Délai</th>
              <th style={{ padding: '10px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 600, color: 'var(--text-muted)', borderBottom: '1px solid var(--border-default)' }}>Détail</th>
            </tr>
          </thead>
          <tbody>
            {RULES.map(({ module, icon, regles }) =>
              regles.map((r, i) => (
                <tr key={`${module}-${i}`} style={{ borderBottom: '1px solid var(--border-default)' }}>
                  {i === 0 && (
                    <td rowSpan={regles.length} style={{ padding: '12px 16px', verticalAlign: 'top', fontWeight: 600, fontSize: '13px', color: 'var(--text-primary)', whiteSpace: 'nowrap', borderRight: '1px solid var(--border-default)' }}>
                      {icon} {module}
                    </td>
                  )}
                  <td style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text-secondary)', verticalAlign: 'top' }}>{r.champs}</td>
                  <td style={{ padding: '12px 16px', verticalAlign: 'top', whiteSpace: 'nowrap' }}>
                    <span className="status-info" style={{ fontSize: '12px' }}>{r.regle}</span>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: '12px', fontWeight: 600, color: 'var(--text-primary)', verticalAlign: 'top', whiteSpace: 'nowrap' }}>{r.delai}</td>
                  <td style={{ padding: '12px 16px', fontSize: '12px', color: 'var(--text-secondary)', verticalAlign: 'top', lineHeight: '1.5' }}>{r.detail}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
